// extracted by mini-css-extract-plugin
export default {"cls1":"EditPayeeForm-Card_cls1__OjgDf","cls2":"EditPayeeForm-Card_cls2__XQft- EditPayeeForm-Card_cls1__OjgDf"};